import { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useTelegram } from './hooks/useTelegram';
import { api } from './services/api';
import { BrowsePage } from './pages/BrowsePage';
import { EstatePage } from './pages/EstatePage';
import { BookingPage } from './pages/BookingPage';
import { Layout } from './components/Layout';

function App() {
  const { initData, isReady, startParam, webApp } = useTelegram();
  const navigate = useNavigate();

  // Set initData for API calls - check multiple sources
  useEffect(() => {
    // Try hook's initData first
    if (initData && initData.length > 0) {
      console.log('[App] Setting initData from hook, length:', initData.length);
      api.setInitData(initData);
      return;
    }
    
    // Try webApp directly
    if (webApp) {
      const directInitData = webApp.initData;
      if (directInitData && directInitData.length > 0) {
        console.log('[App] Setting initData from webApp directly, length:', directInitData.length);
        api.setInitData(directInitData);
        return;
      }
    }
    
    // Try window.Telegram.WebApp directly as fallback
    const tg = window.Telegram?.WebApp;
    if (tg?.initData && tg.initData.length > 0) {
      console.log('[App] Setting initData from window.Telegram.WebApp, length:', tg.initData.length);
      api.setInitData(tg.initData);
      return;
    }
    
    console.error('[App] No initData found from any source!', {
      hookInitData: initData,
      webAppInitData: webApp?.initData,
      windowTgInitData: tg?.initData,
      hasWebApp: !!webApp,
      hasWindowTg: !!tg,
    });
  }, [initData, webApp]);

  // Handle deep linking from Telegram
  useEffect(() => {
    if (isReady && startParam) {
      // Parse startParam like "estate_cambo-house"
      if (startParam.startsWith('estate_')) {
        const estateId = startParam.replace('estate_', '');
        navigate(`/estate/${estateId}`);
      }
    }
  }, [isReady, startParam, navigate]);

  if (!isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-primary text-foreground">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-foreground border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-300 text-sm uppercase tracking-[0.24em]">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<BrowsePage />} />
        <Route path="/estate/:id" element={<EstatePage />} />
        <Route path="/booking/:id" element={<BookingPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
